import { UrlRequiredError } from '../../errors/transport.js';
import { getSocket, rpc } from '../../utils/rpc.js';
import { createTransport, } from './createTransport.js';
export function webSocket(url, config = {}) {
    const { key = 'webSocket', name = 'WebSocket JSON-RPC', retryDelay } = config;
    return ({ chain, retryCount: retryCount_, timeout: timeout_ }) => {
        const retryCount = config.retryCount ?? retryCount_;
        const timeout = timeout_ ?? config.timeout ?? 10000;
        const url_ = url || chain?.rpcUrls.default.webSocket?.[0];
        if (!url_)
            throw new UrlRequiredError();
        return createTransport({
            key,
            name,
            async request({ method, params }) {
                const socket = await getSocket(url_);
                const { result } = await rpc.webSocketAsync(socket, {
                    body: { method, params },
                    timeout,
                });
                return result;
            },
            retryCount,
            retryDelay,
            timeout,
            type: 'webSocket',
        }, {
            getSocket() {
                return getSocket(url_);
            },
            async subscribe({ params, onData, onError }) {
                const socket = await getSocket(url_);
                const { result: subscriptionId } = await new Promise((resolve, reject) => rpc.webSocket(socket, {
                    body: {
                        method: 'eth_subscribe',
                        params,
                    },
                    onData: (data) => {
                        if (typeof data.id === 'number') {
                            resolve(data);
                            return;
                        }
                        if (data.method !== 'eth_subscription')
                            return;
                        onData(data.params);
                    },
                    onError: (error) => {
                        reject(error);
                        onError?.(error);
                    },
                }));
                return {
                    subscriptionId,
                    async unsubscribe() {
                        return new Promise((resolve, reject) => rpc.webSocket(socket, {
                            body: {
                                method: 'eth_unsubscribe',
                                params: [subscriptionId],
                            },
                            onData: resolve,
                            onError: reject,
                        }));
                    },
                };
            },
        });
    };
}
//# sourceMappingURL=webSocket.js.map